var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataPic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4369_9989)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 42.707C0.5 19.5111 19.304 0.707031 42.5 0.707031C65.696 0.707031 84.5 19.5111 84.5 42.707C84.5 65.903 65.696 84.707 42.5 84.707C19.304 84.707 0.5 65.903 0.5 42.707Z",
    fill: "url(#paint0_linear_4369_9989)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5398 53.5658C33.5065 56.1793 31.36 58.1592 27.0998 59.4458C32.233 63.179 37.3666 66.1658 42.4998 66.1658C47.633 66.1658 52.7666 63.179 57.8998 59.4458C53.6686 58.1578 51.522 56.2351 51.4598 53.6778C51.4598 53.222 51.4898 43.2072 51.5091 38.8378C55.522 33.6362 54.0478 27.5381 52.7904 27.6902C51.2487 27.878 37.8918 15.203 35.3298 14.5531C32.7678 13.9032 26.2598 16.0013 25.1398 21.8463C24.0198 27.6913 23.5516 42.4243 27.7998 48.3063C29.0086 49.9801 30.9411 50.6303 33.5398 50.2663C33.5434 51.4896 33.5398 53.5658 33.5398 53.5658Z",
    fill: "url(#paint1_linear_4369_9989)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5398 50.2662C39.6998 49.5662 43.6198 46.9062 43.6198 46.9062C43.6198 46.9062 40.2598 52.5062 33.5398 53.6262V50.2662Z",
    fill: "#DB6F3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5599 38.9261C55.4891 34.2865 63.2199 24.8373 56.5559 18.9573C54.3159 8.03733 41.9399 9.24609 33.6799 11.7661C28.1284 13.4598 23.9359 16.8061 23.0399 14.2861C17.4399 18.9573 20.2444 23.5261 23.9359 24.8373C27.2864 26.0273 32.9519 27.2173 42.5856 26.0973C44.3065 25.8971 43.9461 31.1676 44.8656 31.7374C46.2452 32.5922 47.3159 27.2173 51.0982 28.8312C54.8804 30.4452 52.6359 37.9284 48.5759 37.9284C47.1759 37.9284 46.4759 41.7776 50.2559 43.5976C52.9999 44.9461 52.3064 41.9408 53.5599 38.9261Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8999 67.9931C74.5655 73.4131 76.0999 85.9131 76.0999 85.9131H8.8999C8.8999 85.9131 10.4349 73.4117 13.0999 67.9931C15.7649 62.5746 31.3279 57.5488 31.3279 57.5488C34.3275 63.7069 50.7901 63.7069 53.6638 57.5469C53.6638 57.5469 69.2343 62.5732 71.8999 67.9931Z",
    fill: "url(#paint2_linear_4369_9989)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4369_9989",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 57,
    width: 69,
    height: 29
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8999 67.9931C74.5655 73.4131 76.0999 85.9131 76.0999 85.9131H8.8999C8.8999 85.9131 10.4349 73.4117 13.0999 67.9931C15.7649 62.5746 31.3279 57.5488 31.3279 57.5488C34.3275 63.7069 50.7901 63.7069 53.6638 57.5469C53.6638 57.5469 69.2343 62.5732 71.8999 67.9931Z",
    fill: "url(#paint3_linear_4369_9989)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4369_9989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09985 80.2271V77.9871H78.8999V80.2271H6.09985ZM6.09985 74.6271V72.3871H78.8999V74.6271H6.09985ZM6.09985 69.0271V66.7871H78.8999V69.0271H6.09985Z",
    fill: "#5A5B6E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4369_9989",
    x1: 42.5,
    y1: 84.707,
    x2: 42.5,
    y2: 0.707031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4369_9989",
    x1: 41.1339,
    y1: 14.4395,
    x2: 41.1339,
    y2: 66.1658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6864E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB965E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4369_9989",
    x1: 42.4999,
    y1: 57.5469,
    x2: 42.4999,
    y2: 85.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4369_9989",
    x1: 42.4999,
    y1: 57.5469,
    x2: 42.4999,
    y2: 85.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4369_9989"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 42.707C0.5 19.5111 19.304 0.707031 42.5 0.707031C65.696 0.707031 84.5 19.5111 84.5 42.707C84.5 65.903 65.696 84.707 42.5 84.707C19.304 84.707 0.5 65.903 0.5 42.707Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPic);
export default __webpack_public_path__ + "static/media/dataPic.7ba4f3656d953981715b3729d497fdd9.svg";
export { ForwardRef as ReactComponent };